module.exports = __webpack_public_path__ + "static/img/0.229f07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/0.png
// module id = n3GW
// module chunks = 12